// extracted by mini-css-extract-plugin
export default {"eventCardLightList":"EventCardLightList_eventCardLightList__UwPz5","eventCardLight":"EventCardLightList_eventCardLight__SO+ul"};